import { render } from "./success.vue?vue&type=template&id=6f24e339&scoped=true"
import script from "./success.vue?vue&type=script&lang=js"
export * from "./success.vue?vue&type=script&lang=js"

import "./success.vue?vue&type=style&index=0&id=6f24e339&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/LBP/mi-stock-lbp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f24e339"]])

export default __exports__